import qs from 'qs';

import RouterLink from '../../generic/Link/RouterLink';
import type { AuthPage } from '../index';

type TextMap = {
  to: string;
  link: string;
  text: string;
};

type SignInSignUpToggleProps = {
  page: AuthPage;
  email: string;
  next?: string;
};

//  Map for determining which text to render.
const textMap: Record<AuthPage, TextMap> = {
  login: {
    to: '/auth/register',
    text: 'No account?',
    link: 'Sign up for FOSSA',
  },
  register: {
    to: '/auth/login',
    text: 'Already have an account?',
    link: 'Sign in',
  },
};

/**
 * Appends query params (email, next) to the toggle link URL.
 * @param {string} to - Where to link to.
 * @param {string} email - The user's email (if it exists).
 * @param {string} next - The URL to redirect to after authentication.
 * @returns {string} The URL with query params appended.
 */
function appendQueryParams(to: string, email?: string, next?: string): string {
  const params = qs.stringify({ email: email || undefined, next }, { skipNulls: true });
  return params ? `${to}?${params}` : to;
}

/**
 * Renders the link to "toggle" between signing up and logging in.
 */
const SignInSignUpToggle = ({ page = 'login', email, next }: SignInSignUpToggleProps) => {
  const { link, to, text } = textMap[page];
  return (
    <div className="fossa-auth__page-link-toggle">
      {text}
      {' '}
      <RouterLink to={appendQueryParams(to, email, next)}>
        {link}
      </RouterLink>
    </div>
  );
};

export default SignInSignUpToggle;
